import { useCallback, FC } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import LoadingButton from '@mui/lab/LoadingButton';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDeleteAdMutation } from '@/models/ad';
import { useNavigate } from 'react-router';

export const DeleteAdModal: FC<{
  id?: string;
  open: boolean;
  onClose: () => void;
}> = ({ id, open, onClose }) => {
  const navigate = useNavigate();
  const [deleteAd, { isLoading }] = useDeleteAdMutation();
  const { t } = useTranslation();

  const handleDelete = useCallback(async () => {
    try {
      await deleteAd({ id: id! }).unwrap();
      navigate(-1);
    } catch (error) {
      console.error('Failed to delete ad:', error);
    } finally {
      onClose();
    }
  }, [id, deleteAd, onClose, navigate]);

  if (!id) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth={'sm'}>
      <DialogTitle>{t('label.delete_advert')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('label.confrim_delete')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          {t('label.no')}
        </Button>
        <LoadingButton loading={isLoading} onClick={handleDelete}>
          {t('label.delete')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
